"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _user = require("@/api/user");
var _permission = require("@/utils/permission");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 权限判断函数
var _default = exports.default = {
  name: 'levelConfig',
  data: function data() {
    return {
      formConf: {
        fields: []
      },
      loading: false,
      keyNum: 0,
      editData: {},
      formName: 'userlevelConfig'
    };
  },
  created: function created() {
    //this.keyNum += 1
    this.getConfigInfo();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    //立即前往
    handlerToLink: function handlerToLink(url) {
      var _this$$router$resolve = this.$router.resolve({
          path: url
        }),
        href = _this$$router$resolve.href;
      window.open(href);
    },
    handlerSubmit: function handlerSubmit(formValue) {
      var _this = this;
      if ((0, _permission.checkPermi)(['platform:system:user:level:config:update'])) {
        (0, _user.systemUserLevelUpdateConfigApi)(formValue).then(function (res) {
          _this.$message.success('操作成功');
          _this.getConfigInfo();
        }).catch(function () {
          _this.loading = false;
        });
      } else {
        this.$message.warning('暂无操作权限');
      }
    },
    // 获取配置信息
    getConfigInfo: function getConfigInfo() {
      var _this2 = this;
      this.keyNum += 1;
      this.loading = true;
      (0, _user.systemUserLevelConfigApi)().then(function (res) {
        _this2.editData = res;
        _this2.loading = false;
      }).catch(function () {
        _this2.loading = false;
      });
    }
  }
};